import { useMutation } from '@tanstack/react-query';
import { supportApi } from 'API/offline-reports-api';
import { PostAccountOwnerEmailPayload } from 'API/offline-reports-api/types';

export const useSendAccountOwnerEmailMutation = () => {
    return useMutation({
        mutationKey: ['send-account-owner-email'],
        mutationFn: (payload: PostAccountOwnerEmailPayload) => {
            return supportApi.postAccountOwnerEmail(payload);
        },
    });
};
